const quiz =  function () {
  return {
    products: [],
    step_length: 0,
    step: 1,
    preloader: false,
    form_submited: this.$persist(false),
    show_products: false,
    show_copied: false,
    filtered_products: [],
    products_html: [],
    start_quiz: false,
    id_list: [],

    checkProducts(answer) {
      this.products.forEach((product)=> {
        if(product.options.includes(answer)) {
          product.rating += 1;
        }
      })
      this.step += 1;
      this.show_products = false;
      this.$el.classList.add('active');

      if (this.step > this.step_length) {
        this.getProducts();
      }
    },

    sortProducts() {
      const sorted_products = this.products.slice(0,3);
      this.filtered_products = sorted_products;
    },

    getKlavyioForm(products) {
      if (!this.form_submited) {
        const klaviyo_form_id = 'XfD5nS';
        window._klOnsite = window._klOnsite || [];
        
        console.log('Recommended Products:', this.id_list);
        console.log('Quiz Results:', products);
        
        klaviyo.push(['identify', {
          'Recommended Products' : this.id_list,
          'Quiz Results' : products
        }]);
        
        window.addEventListener("klaviyoForms", function(e) {
          console.log('Klaviyo Form event received:', e.detail);
    
          if (e.detail.type == '"stepSubmit"' && e.detail.formId == klaviyo_form_id) {
            this.form_submited = true;
            console.log('Form has been submitted');
          }
        });
      } else {
        console.log('Form was already submitted before');
      }
    },

    getProducts() {
      this.preloader = true;
      if (this.products.length > 0) {
        this.products.forEach((product) => {
            const url = `${window.Shopify.routes.root}products/${product.handle}?view=card`;
            fetch(url)
                .then((res) => res.text())
                .then((data) => {
                  const parser = new DOMParser().parseFromString(data, 'text/html');
                  const card = parser.querySelector('.quiz-card');
                  card.setAttribute("data-rating", `${product.rating}`);
                  card.setAttribute("data-product-id", product.id);
                  this.products_html.push(card);
                  this.id_list.push(product.id);
                })
                .catch((error) => {
                    console.log(error);
                });
        });
        setTimeout(()=> {
        const sorted  =  this.products_html.sort((a, b) => b.dataset.rating - a.dataset.rating).slice(0,3);
        const banner = `<div class="featured-banner"><span>Our
          Recommendation</span></div>`;
          const first_item = sorted[1];
          sorted[1] =  sorted[0];
          sorted[0] = first_item;
          const featured = sorted[1].querySelector('.quiz-card__container');
          featured.insertAdjacentHTML('afterbegin', banner);
          featured.classList.add('featured');
          
          const sortedProductIds = sorted.map(card => card.getAttribute('data-product-id'));
          
          sorted.forEach((card)=> {
            this.$refs.productContainer.insertAdjacentHTML('beforeend', card.innerHTML);  
          })
          
          this.preloader = false;
          this.show_products = true;
          this.getKlavyioForm(sortedProductIds);
        }, 1000);
      } else return;  
    },
    openQuiz() {
      document.getElementsByTagName('html')[0].classList.add('no_scroll');
      this.start_quiz = true;
    },

    closeQuiz() {
      document.getElementsByTagName('html')[0].classList.remove('no_scroll');
      this.start_quiz = false;
      this.show_products = false;
      this.step = 1;
      this.products_html = [];
      this.$refs.productContainer.innerHTML = '';
      document.querySelectorAll('.quiz__answer').forEach((el)=> {
        el.classList.remove('active');
      })
    },

    copyCode(code) {
      window.navigator.clipboard.writeText(code);
      this.show_copied = true;
      setTimeout(()=> {
        this.show_copied = false;  
      }, 500)
    }
  }
}

document.addEventListener('alpine:init', () => {
	Alpine.data('quiz', quiz);
});